import PAText from "component/design-system/typography/PAText/PAText";
import styles from "./headings.module.scss";

interface IProps {
    heading: string;
    id?: string;
    component?: string;
    className?: string;
}

const Heading = (props: IProps) => {
  const {
    heading, component, className, bold = true,
  } = props;

  return (
    <PAText
      component={component || "h3"}
      bold={bold}
      {...props}
      className={`${styles.heading} ${className}`}
    >
      {heading}
    </PAText>
  );
};

export default Heading;
